import { Alert } from "@svea/design-system-components-react";
import { useApplicationDetails } from "../../hooks/application";
import { usePageContext } from "../../hooks/context";
import { isCreditWorthy } from "./helpers";
import { useChoosePackage } from "./hooks";

export const CreditAlert = () => {
	const { creditScore, availablePackages } = usePageContext(useChoosePackage);
	const isForetagarnaMember = availablePackages.find((p) => p?.packageId === "FÖRETAGARNA-BAS");
	const { applicationDetails } = useApplicationDetails();

	const interestPromotion = applicationDetails?.promotions.find(
		(p) => p.promotionType === "interestRateDiscount",
	);

	if (!creditScore.assessment || !isCreditWorthy(creditScore.assessment)) return;

	return interestPromotion ? (
		<Alert kind="information" title="Rabatten är aktiverad!">
			Din kampanjränta hittar du intill varje paket och tillvalsprodukt. Den gäller fram till 31
			mars 2027 och återgår därefter till din ordinarie årsränta.
		</Alert>
	) : isForetagarnaMember ? null : (
		<Alert kind="information" title="Få tillgång till kapital mot låg månadskostnad">
			Jämna ut kassaflödet med kontokredit och få en{" "}
			<strong>
				förmånlig månadsränta på {creditScore.assessment?.check.monthlyInterestRate} %
			</strong>{" "}
			på krediten du använder. Kontokredit ingår i företagspaketen Växa och Finansiera.
		</Alert>
	);
};
